export function peselValidator(pesel) {
  const reg = /^[0-9]{11}$/;

  if (reg.test(pesel) == false) {
    return false;
  } else {
    const digits = ("" + pesel).split("");

    if (
      parseInt(pesel.substring(4, 6)) > 31 ||
      (parseInt(pesel.substring(2, 4)) > 12 &&
        (21 > parseInt(pesel.substring(2, 4)) ||
          parseInt(pesel.substring(2, 4)) > 32))
    ) {
      return false;
    }

    let checksum =
      (1 * parseInt(digits[0]) +
        3 * parseInt(digits[1]) +
        7 * parseInt(digits[2]) +
        9 * parseInt(digits[3]) +
        1 * parseInt(digits[4]) +
        3 * parseInt(digits[5]) +
        7 * parseInt(digits[6]) +
        9 * parseInt(digits[7]) +
        1 * parseInt(digits[8]) +
        3 * parseInt(digits[9])) %
      10;
    if (checksum == 0) {
      checksum = 10;
    }
    checksum = 10 - checksum;

    return parseInt(digits[10]) == checksum;
  }
}

export function nipValidator(nip) {
  if (nip) {
    var nipWithoutDashes = nip.replace(/-/g, "");
    var reg = /^[0-9]{10}$/;
    if (reg.test(nipWithoutDashes) == false) {
      return false;
    }
    var digits = ("" + nipWithoutDashes).split("");
    var checksum =
      (6 * parseInt(digits[0]) +
        5 * parseInt(digits[1]) +
        7 * parseInt(digits[2]) +
        2 * parseInt(digits[3]) +
        3 * parseInt(digits[4]) +
        4 * parseInt(digits[5]) +
        5 * parseInt(digits[6]) +
        6 * parseInt(digits[7]) +
        7 * parseInt(digits[8])) %
      11;

    return parseInt(digits[9]) == checksum;
  }
  return false;
}

export function regon9Validator(regon) {
  if (regon) {
    var reg = /^[0-9]{9}$/;
    if (!reg.test(regon)) {
      return false;
    }
    var digits = ("" + regon).split("");
    var checksum =
      (8 * parseInt(digits[0]) +
        9 * parseInt(digits[1]) +
        2 * parseInt(digits[2]) +
        3 * parseInt(digits[3]) +
        4 * parseInt(digits[4]) +
        5 * parseInt(digits[5]) +
        6 * parseInt(digits[6]) +
        7 * parseInt(digits[7])) %
      11;
    if (checksum == 10) checksum = 0;

    return parseInt(digits[8]) == checksum;
  }
  return false;
}
export function postCodePolishValidator(postCode) {
  if (postCode) {
    var reg = /^[0-9]{2}-$[0-9]{3}/;
    return !reg.test(postCode);
  }
  return false;
}

export const getBirthdateFromPesel = (pesel) => {
  const stringifyPesel = `${pesel}`;

  if (!stringifyPesel) return undefined;

  let year = +stringifyPesel.slice(0, 2);
  let month = +stringifyPesel.slice(2, 4);
  let day = +stringifyPesel.slice(4, 6);

  if (month > 80) {
    year = year + 1800;
    month = month - 80;
  } else if (month > 60) {
    year = year + 2200;
    month = month - 60;
  } else if (month > 40) {
    year = year + 2100;
    month = month - 40;
  } else if (month > 20) {
    year = year + 2000;
    month = month - 20;
  } else {
    year += 1900;
  }

  let monthStr = month < 10 ? `0${month}` : month;
  let dayStr = day < 10 ? `0${day}` : day;

  return `${year}-${monthStr}-${dayStr}`;
};
